import AppHeader from "~/components/AppHeader";

const FullBlankPage = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="w-full h-full">
            <AppHeader />

            {children}
        </div>
    );
};

export default FullBlankPage;
